import { GDFCustomRecord } from '../../gdf/type';
import { getCopyButtonComponent } from '../copy-button';

export default function CustomRecordProperties({ record }: { record: GDFCustomRecord }) {
    const Button = getCopyButtonComponent();
    return (
        <div>
            <div className="pb-2">{record.menu}</div>
            {Button && (
                <div className="d-flex justify-content-start pb-2">
                    <Button getText={() => record.properties} />
                </div>
            )}
            <pre className="secondary-bg-color p-2 " style={{ fontFamily: 'monospace' }}>
                {record.properties}
            </pre>
        </div>
    );
}
